import { useState } from "react";

export const useFormInput = (initialValue) => {

    const [value, setValue] = useState(initialValue);

    const handleChange = (e) => setValue(e.target.value);

    const handleReset = () => setValue("");

    return {
        value,
        onChange: handleChange,
        onReset: handleReset,
        setValue
    };
}

export default useFormInput;